import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import './PrizeTable.css';

const PrizeTable = ({ prizes, showRate = false }) => {

    return (
        <TableContainer component={Paper} sx={{ marginTop: 4 }}>
            <h3 style={{ textAlign: "center", marginBottom: "20px" }}>Danh sách Giải Thưởng</h3>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>STT</TableCell>
                        <TableCell>Giải Thưởng</TableCell>
                        <TableCell >Số Lượng</TableCell>
                        {showRate && <TableCell align="right">Tỷ Lệ</TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {prizes.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell><span className='name'>{item.name}</span></TableCell>
                            <TableCell><span className='quantity'>{item.quantity}</span></TableCell>
                            {showRate && <TableCell  >{item.probability}</TableCell>}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PrizeTable;
